import { render, staticRenderFns } from "./InformacionGlobalCliente.vue?vue&type=template&id=06b79ece&"
import script from "./InformacionGlobalCliente.vue?vue&type=script&lang=js&"
export * from "./InformacionGlobalCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports